import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { useStore } from "./Store";
import { ComputedMarker } from '@/shared/types/zod';
import { getLineIndex } from "@/utils/lineSampling";

type Result = {
	name: string;
	startNo: number;
	initials: string;
	distance: number;
	distanceString: string;
	timeString: string;
	routeIndex: number;
	distanceProgress: number;
	lastSplitPoint: string,
	lastSplitTime: string,
	status: number,
	statusString: string,
};


type LiveMarker = ComputedMarker & {
	properties: ComputedMarker["properties"] & {
		type: "live";
	}
}

export const useLiveStore = defineStore("live", () => {

	const store = useStore()

	const results = ref<Result[]>([]);



	const resultFeatures = computed(() => {
		//copied from MpaTrack, could be done earlier in a global place to not have this run over again //TODO
		const routes = store.routes.map((route) => {
			return {
				type: "Feature" as const,
				id: route.id,
				geometry: {
					type: "LineString" as const,
					coordinates: route.geometry.coordinates.flat(),
				},
				properties: { ...route.properties },
			};
		});
		return results.value
			.map((f: Result) => {
				const route = routes[f.routeIndex];

				let desc = "";
				if (f.statusString) {
					desc += `<b>Status:</b> ${f.statusString}<br>`
				}
				if (f.lastSplitPoint) {
					desc += `<b>Senaste passering:</b> ${f.lastSplitPoint} ${f.lastSplitTime}<br>`
				}
				if (f.status == 1 && f.timeString) {
					desc += `<b>Tid:</b> ${f.timeString}<br>`
				}
				if (f.status == 1 && f.distanceString) {
					desc += `<b>Ungefärlig distans:</b> ${f.distanceString} km<br>`
				}

				if (route) {
					const index = getLineIndex(route.geometry);
					const distance = f.status == 2 ? index.length : f.distance
					const pt = index.sampleFeatureAtDistance(distance) as LiveMarker;
					pt.id = f.startNo.toString(),
						pt.properties = {
							id: f.startNo.toString(),
							type: "live",
							icon: "live",
							text: f.initials,
							label: f.name,
							description: desc,
							__progress: [0], //always show marker,
							color: "#008080",
							__zIndex: 2,
							...f,
						};
					return pt;
				} else {
					return undefined;
				}
			})
			.filter(f => f !== undefined)
	})


	function updateResults(_results: Result[]) {
		results.value = _results;
	}

	return {
		resultFeatures,
		updateResults,
	};
})